import Template from "../Template";
import { useSpring, animated } from "@react-spring/web";

interface TemplateAnimationProps {
  currentPage: string;
  templates: { page: string; type: TemplateType; data: any }[];
}

const TemplateAnimation = (props: TemplateAnimationProps) => {
  const { currentPage } = props;
  const { templates } = props;

  return (
    <>
      {templates.map((template, index) => (
        <SingleAnimation key={index} currentPage={currentPage} page={template.page}>
          <Template type={template.type as TemplateType} data={template.data} />
        </SingleAnimation>
      ))}
    </>
  );
};

interface SingleAnimationProps {
  children: React.ReactNode;
  currentPage: string;
  page: string;
}

const SingleAnimation = (props: SingleAnimationProps) => {
  const { children, currentPage, page } = props;

  const animationShow = useSpring({
    opacity: currentPage === page ? 1 : 0,
    zIndex: currentPage === page ? 1 : 0,
    position: "absolute" as React.CSSProperties["position"],
    top: 0,
  });

  return <animated.div style={{ ...animationShow }}>{children}</animated.div>;
};

export default TemplateAnimation;
